<template>
    <div class="computerBox">
        <topBox :title="$route.meta.title" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">

            <p class="mb-4 text-14 text-slate-400 leading-relaxed">{{ $t('text.receiveQrTip') }}</p>

            <!-- 支付宝收款码 -->
            <div class="my-3">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('text.payAlipay') }}</h1>
                <div class="flex flex-col items-center rounded-[24px] border bg-white p-6 shadow-lg">
                    <div class="qr-preview" @click="$refs.alipayInput.click()">
                        <img v-if="preview.alipay || info.alipay_qr" :src="preview.alipay || info.alipay_qr" alt="alipay qr" />
                        <div v-else class="qr-placeholder">
                            <svg class="w-10 h-10 text-slate-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                            </svg>
                            <span>{{ $t('text.uploadAlipayQr') }}</span>
                        </div>
                    </div>
                    <input
                        ref="alipayInput"
                        type="file"
                        accept="image/jpeg,image/png,image/gif,image/webp"
                        class="hidden"
                        @change="onPick('alipay', $event)"
                    />
                    <button
                        type="button"
                        class="mt-4 block w-full px-5 py-[12px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                        @click="$refs.alipayInput.click()"
                    >
                        {{ info.alipay_qr || preview.alipay ? $t('but.reupload') : $t('but.upload') }}
                    </button>
                </div>
            </div>

            <!-- 微信收款码 -->
            <div class="my-3">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('text.payWxpay') }}</h1>
                <div class="flex flex-col items-center rounded-[24px] border bg-white p-6 shadow-lg">
                    <div class="qr-preview" @click="$refs.wxInput.click()">
                        <img v-if="preview.wx || info.wx_qr" :src="preview.wx || info.wx_qr" alt="wx qr" />
                        <div v-else class="qr-placeholder">
                            <svg class="w-10 h-10 text-slate-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                            </svg>
                            <span>{{ $t('text.uploadWxQr') }}</span>
                        </div>
                    </div>
                    <input
                        ref="wxInput"
                        type="file"
                        accept="image/jpeg,image/png,image/gif,image/webp"
                        class="hidden"
                        @change="onPick('wx', $event)"
                    />
                    <button
                        type="button"
                        class="mt-4 block w-full px-5 py-[12px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                        @click="$refs.wxInput.click()"
                    >
                        {{ info.wx_qr || preview.wx ? $t('but.reupload') : $t('but.upload') }}
                    </button>
                </div>
            </div>

            <div class="mt-6 py-[10px]">
                <button
                    type="button"
                    class="block w-full px-5 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                    :disabled="uploading || (!files.alipay && !files.wx)"
                    @click="onSubmit"
                >
                    {{ uploading ? $t('but.uploading') : $t('but.save') }}
                </button>
            </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import axios from 'axios'
import { layer } from 'vue3-layer'

export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            lang: '',
            uploading: false,
            info: {
                alipay_qr: '',
                wx_qr: '',
            },
            files: {
                alipay: null,
                wx: null,
            },
            preview: {
                alipay: '',
                wx: '',
            },
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
        this.loadInfo()
    },
    beforeUnmount() {
        this.revokePreview('alipay')
        this.revokePreview('wx')
    },
    methods: {
        loadInfo() {
            axios.get('/api/m/receive/info', {
                headers: {
                    'Accept-Language': this.lang,
                    token: localStorage.getItem('token'),
                },
            })
            .then((response) => {
                if (response.data.code === 0) {
                    this.info.alipay_qr = response.data.data.alipay_qr || ''
                    this.info.wx_qr = response.data.data.wx_qr || ''
                } else {
                    if (response.data.code === 911) localStorage.removeItem('isLogin')
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        onPick(type, event) {
            const file = event.target.files && event.target.files[0]
            if (!file) return
            if (!/^image\/(jpeg|png|gif|webp)$/.test(file.type)) {
                layer.msg(this.$t('text.receiveQrTypeError'))
                event.target.value = ''
                return
            }
            if (file.size > 2 * 1024 * 1024) {
                layer.msg(this.$t('text.receiveQrSizeError'))
                event.target.value = ''
                return
            }
            this.revokePreview(type)
            this.files[type] = file
            this.preview[type] = URL.createObjectURL(file)
        },
        revokePreview(type) {
            if (this.preview[type] && this.preview[type].startsWith('blob:')) {
                URL.revokeObjectURL(this.preview[type])
            }
            this.preview[type] = ''
        },
        onSubmit() {
            if (this.uploading) return
            if (!this.files.alipay && !this.files.wx) {
                layer.msg(this.$t('text.receiveQrEmpty'))
                return
            }

            const form = new FormData()
            if (this.files.alipay) form.append('alipay', this.files.alipay)
            if (this.files.wx) form.append('wx', this.files.wx)

            this.uploading = true
            axios.post('/api/m/receive/save', form, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept-Language': this.lang,
                    token: localStorage.getItem('token'),
                },
            })
            .then((response) => {
                this.uploading = false
                if (response.data.code === 0) {
                    this.info.alipay_qr = response.data.data.alipay_qr || this.info.alipay_qr
                    this.info.wx_qr = response.data.data.wx_qr || this.info.wx_qr
                    this.files.alipay = null
                    this.files.wx = null
                    this.revokePreview('alipay')
                    this.revokePreview('wx')
                    if (this.$refs.alipayInput) this.$refs.alipayInput.value = ''
                    if (this.$refs.wxInput) this.$refs.wxInput.value = ''
                    layer.msg(response.data.msg)
                } else {
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                this.uploading = false
                console.log(error)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}

.qr-preview {
    width: 200px;
    height: 200px;
    border-radius: 16px;
    border: 1px dashed #cbd5e1;
    background: #f8fafc;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background: #fff;
    }
}

.qr-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    color: #94a3b8;
    font-size: 12px;
    text-align: center;
}
</style>
